enum LSDRadioButtonValue {
  FIXED_TIME = '1',
  LEAD_TIME_AFTER_ESD = '2',
  LEAD_TIME_BEFORE_LDD = '3',
}

export default LSDRadioButtonValue
